import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M17.19 11A6.27 6.27 0 0 0 12.84.25H4.3a1.25 1.25 0 0 0 0 2.5h1a.25.25 0 0 1 .26.25v18a.25.25 0 0 1-.25.25h-1a1.25 1.25 0 0 0 0 2.5h10A6.74 6.74 0 0 0 17.19 11m-4.35-8.25a3.76 3.76 0 0 1 0 7.52H8.31a.25.25 0 0 1-.25-.27V3a.25.25 0 0 1 .25-.25Zm1.42 18.5H8.31a.25.25 0 0 1-.25-.25v-8a.25.25 0 0 1 .25-.25h5.95a4.24 4.24 0 0 1 0 8.48Z"
    }, null, -1)
  ]));
}
const EditorBold = { render };
export {
  EditorBold as default,
  render
};
//# sourceMappingURL=EditorBold.svg.js.map
